module.exports = __webpack_public_path__ + "img/hic-blood-diseases-female.0d186777.png";